import socialApiClient from "./services/social-api-client";
import { buildPostImageFromBlobForSocial } from "./social-post-image-from-blob";
import { PostImage } from "../socialPost/interfaces/postImage";

const OPENAI_IMAGES_ENDPOINT = "openai/images";

const base64ToBlob = (b64: string, mimeType: string) => {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mimeType });
};

export async function generateOpenAiSocialImage(
  companyId: string,
  prompt: string,
  size = "1024x1024"
): Promise<PostImage> {
  const { data } = await socialApiClient().post(
    OPENAI_IMAGES_ENDPOINT,
    { prompt, size },
    { params: { companyId } }
  );

  const payload = data?.payload ?? data;
  const b64 = payload?.b64_json;
  const imageUrl = payload?.url;
  const mimeType = payload?.mimeType || "image/png";

  let blob: Blob;
  if (b64) {
    blob = base64ToBlob(b64, mimeType);
  } else if (imageUrl) {
    const response = await fetch(imageUrl);
    blob = await response.blob();
  } else {
    throw new Error("OpenAI no devolvió una imagen para el posteo.");
  }

  return buildPostImageFromBlobForSocial(
    blob,
    `instagram-ai-post-${Date.now()}.jpg`
  );
}
